import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';
import Get_Order from "../Sub_Componet/Get_Order";

let source = axios.CancelToken.source();

class Follow_up_v2 extends Component {
    constructor() {
        super();
        var date = new Date();
        this.state = {
            locs: [],
            org: "-1",
            des: "-1",
            txtfilter:'',
            allovehs: [],
            datas:[],
            allovehsl: false,
        }
    }

    async componentDidMount() {
        let redirecttologin = myconfig.redirecttologin;
        let baseurl = myconfig.get_location;
        this.setState({
            allovehs: [],
            allovehsl: false,
            cushow: false,
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            order_id: this.state.order_id,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                console.log(res.data)
                this.setState({
                    locs: res.data.datas,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    inputmgtfilter = (event) => {
        event.preventDefault();
        if (this.state.allovehsl) {
            var name = event.target.name;
            var value = event.target.value;
            this.setState({
                [name]: value,
            })
            let temp =this.state.allovehs.datas;
            if (value != "") {
                temp = temp.filter(v => {
                    if (v.plate_no.toUpperCase().includes(value.toUpperCase())) {
                        return value;
                    }
                })
            }
            this.setState({
                datas: temp,
            })
        }
    }
    btngetreport = (event) => {
        event.preventDefault();
        this.setState({
            allovehs: [],
            datas:[],
            txtfilter:'',
            allovehsl: false,
        })
        let redirecttologin = myconfig.redirecttologin;
        let baseurl = myconfig.get_follow_up;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            org: this.state.org,
            des: this.state.des,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                Swal.fire({
                    title: 'Success!',
                    text: res.data.msg,
                    icon: 'success',
                    confirmButtonText: 'Okay'
                })

                this.setState({
                    allovehs: res.data,
                    datas: res.data.datas,
                    allovehsl: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });

    }
    datemgt = (event, id) => {
        event.preventDefault();
        let url = myconfig.redirectodate_v2 + "?id=" + id
        const datewindow = window.open(url, "datemgt", "width=500,height=500", true);
    }
    tabledata = () => {
        let retdata = null;
        if (this.state.allovehsl) {
            let datatable = this.state.datas.map(value => {
                return (<>
                        <table className="table table-head-fixed text-nowrap pt-3">
                            <tr>
                                <th colSpan={4}>{value.plate_no} ({value.status})</th>
                            </tr>
                            <tr>
                                <th>Customer</th>
                                <td>{value.customer_id}</td>
                                <th>Cargo</th>
                                <td>{value.cargo_id}</td>
                                <th>Location</th>
                                <td colSpan={4}>{value.loc}</td>
                                <th>Update Time</th>
                                <td>{value.avltime}</td>
                            </tr>
                            <tr>
                                <th>Allocation</th>
                                <td>{value.dateofallocation}</td>
                                <th>Arrival @ Load</th>
                                <td>{value.dateofarivalatloadpoint}</td>
                                <th>Load</th>
                                <td>{value.dateofloading}</td>
                                <th>Departure</th>
                            </tr>
                            <tr>
                                <td>{value.dateofdeparture}</td>
                                <th>Arrival @ Unload</th>
                                <td>{value.dateofarivalatoffloadpoint}</td>
                                <th>Unload</th>
                                <td>{value.dateofoffloading}</td>
                                <th>KM To Destination</th>
                                <td>{value.km}</td>
                            </tr>
                        </table>
                        <table className="table table-head-fixed text-nowrap">
                            <tr>
                                <th>Hour 00</th>
                                <td>{value.date_00}</td>
                                <th>Hour 01</th>
                                <td>{value.date_01}</td>
                                <th>Hour 02</th>
                                <td>{value.date_02}</td>
                                <th>Hour 03</th>
                                <td>{value.date_03}</td>
                                <th>Hour 04</th>
                                <td>{value.date_04}</td>
                                <th>Hour 05</th>
                                <td>{value.date_05}</td>
                            </tr>
                            <tr>
                                <th>Hour 06</th>
                                <td>{value.date_06}</td>
                                <th>Hour 07</th>
                                <td>{value.date_07}</td>
                                <th>Hour 08</th>
                                <td>{value.date_08}</td>
                                <th>Hour 09</th>
                                <td>{value.date_09}</td>
                                <th>Hour 10</th>
                                <td>{value.date_10}</td>
                                <th>Hour 11</th>
                                <td>{value.date_11}</td>
                            </tr>
                            <tr>
                                <th>Hour 12</th>
                                <td>{value.date_12}</td>
                                <th>Hour 13</th>
                                <td>{value.date_13}</td>
                                <th>Hour 14</th>
                                <td>{value.date_14}</td>
                                <th>Hour 15</th>
                                <td>{value.date_15}</td>
                                <th>Hour 16</th>
                                <td>{value.date_16}</td>
                                <th>Hour 17</th>
                                <td>{value.date_17}</td>
                            </tr>
                            <tr>
                                <th>Hour 18</th>
                                <td>{value.date_18}</td>
                                <th>Hour 19</th>
                                <td>{value.date_19}</td>
                                <th>Hour 20</th>
                                <td>{value.date_20}</td>
                                <th>Hour 21</th>
                                <td>{value.date_21}</td>
                                <th>Hour 22</th>
                                <td>{value.date_22}</td>
                                <th>Hour 23</th>
                                <td>{value.date_23}</td>
                            </tr>
                        </table>
                    </>
                )
            })
            retdata = <div className="card-body table-responsive p-2">
                {datatable}
            </div>
        }
        return (<>{retdata}</>)
    }
    cboorg = () => {
        let optiondata = this.state.locs.map(value => {
            return (<option value={value.id}>{value.loc_full_name}</option>)
        })
        return (<>{optiondata}</>)
    }
    cbodes = () => {
        let optiondata = this.state.locs.map(value => {
            return (<option value={value.id}>{value.loc_full_name}</option>)
        })
        return (<>{optiondata}</>)
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    render() {
        return (
            <>
                <Nav type="follow_up_v2"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Follow-up V2</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Follow-up</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="card card-primary">
                                    <div className="card-header">
                                        <h3 className="card-title">Follow-up Criteria</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="card-body">
                                            <div className="form-group">
                                                <label>Origin</label>
                                                <select className="form-control" value={this.state.org} name="org"
                                                        onChange={this.inputmgt}>
                                                    <option value="-1">--Select Origin--</option>
                                                    {this.cboorg()}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>Destination</label>
                                                <select className="form-control" value={this.state.des} name="des"
                                                        onChange={this.inputmgt}>
                                                    <option value="-1">--Select Destination--</option>
                                                    {this.cbodes()}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="card-footer">
                                            <button type="submit" className="btn btn-primary"
                                                    onClick={this.btngetreport}>Get Report
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                <input type="text" name="txtfilter" value={this.state.txtfilter} onChange={this.inputmgtfilter} className="form-control float-right" placeholder="Search" />
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-header">
                                        <h6><strong>Driver Follow-up</strong></h6>
                                    </div>
                                    <div className="card-body">
                                        {this.tabledata()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default Follow_up_v2;
